import { Fragment } from "react";
import styles from "./Loader.module.css";

const NetworkLoader = () => {
  return (
    <Fragment>
      <div className={styles.cssloadContainer}>
        <div className={styles.cssloadZenith}></div>
      </div>
    </Fragment>
  );
};

export default NetworkLoader;
